import { render, staticRenderFns } from "./PhonePage.vue?vue&type=template&id=4b4e55a4&scoped=true"
import script from "./PhonePage.vue?vue&type=script&lang=js"
export * from "./PhonePage.vue?vue&type=script&lang=js"
import style0 from "./PhonePage.vue?vue&type=style&index=0&id=4b4e55a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e55a4",
  null
  
)

export default component.exports